import React from 'react';
import ReactDOM from 'react-dom/client';
import { HelmetProvider } from 'react-helmet-async';
import { Provider } from 'react-redux';
import { BrowserRouter } from "react-router-dom";
import { PersistGate } from 'redux-persist/integration/react';
import App from './App';
import WSRayTeams from './components/socket/WSRayTeams';
import "./config/i18n";
import { persistor, store } from './store';
import "./index.css";

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <Provider store={store}>
    <PersistGate loading={null} persistor={persistor}>
      <HelmetProvider>
        <BrowserRouter>
          <App />
          <WSRayTeams />
        </BrowserRouter>
      </HelmetProvider>
    </PersistGate>
  </Provider>
);

